
// SVG Icon: about
export default { id: "terriajs-about" };
export const id = "terriajs-about";
export const name = "about";
